import React from 'react'
import cn from 'classnames'

import './Alert.less'

type AlertVariant = 'danger'

type AlertProps = {
  variant?: AlertVariant
  onDismiss?: () => void
  className?: string
  children?: React.ReactNode
}

function Alert({ variant = 'danger', onDismiss, className, children }: AlertProps) {
  return (
    <div className={cn('alert', `alert-${variant}`, className)} role="alert">
      {onDismiss ? (
        <button type="button" className="alert-dismiss" onClick={onDismiss}>
          &times;
        </button>
      ) : null}
      {children}
    </div>
  )
}

export default Alert
